import { some, last, range, isString } from 'lodash';
import { UnitField } from '@scale/shared/types/params/textcollection';
import {
  createDefaultResponseForFields,
  findPathsToAnnotationsForTemplating,
  getValidValuesForFieldId,
} from '@scale/shared/textcollection/helpers';

const tcGetResponseTemplatePaths = (fields: UnitField[]) => {
  const emptyResponse = createDefaultResponseForFields(fields);
  const paths: string[] = findPathsToAnnotationsForTemplating(emptyResponse);
  return range(paths.length).map(index => {
    const fieldId = last(paths[index].split('.'));
    if (!fieldId) return { path: `context.response.${paths[index]}.response[0]` }; // Should not happen
    const {
      values: expectedValues,
      valuesWithLabels: expectedValuesWithLabels,
      expectsArray,
      fieldTitle,
    } = getValidValuesForFieldId(fields, fieldId) ?? {};
    return {
      path: `context.response.${paths[index]}.response[0]`,
      label: `${fieldTitle} (${fieldId})`,
      expectsArray,
      expectedValues,
      expectedValuesWithLabels,
      parseAsPrimitive: expectedValues ? some(expectedValues, (v: any) => !isString(v)) : undefined,
      fieldId,
    };
  });
};

export default tcGetResponseTemplatePaths;
